export const blockIconsFileApproval = (
	<span className='material-symbols-outlined'>approval</span>
);
